export default __webpack_public_path__ + "static/media/171-galapagos-islands.0c2e4e25.svg";